<div class="container">
	@if (kanSwitchen()) {
		<button type="button" class="profiel is-klikbaar" (click)="kies('switch')">
			<ng-container [ngTemplateOutlet]="kopInhoud" />
			<app-icon name="switch" size="medium" color="primary-1" />
		</button>
	} @else {
		<div class="profiel">
			<ng-container [ngTemplateOutlet]="kopInhoud" />
		</div>
	}
	<ng-template #kopInhoud>
		<app-pasfoto size="size-3" [pasfotoKey]="pasfotoKey()" />
		<div class="profiel-tekst">
			<span class="naam">{{ userService.begroetingsnaam() }}</span>
			<span class="school">{{ schoolnaam() }}</span>
		</div>
	</ng-template>

	<div class="acties">
		@for (item of items(); track item.actie) {
			<button type="button" class="actie" (click)="kies(item.actie)">
				<app-icon [name]="item.icon" size="medium" color="typography-1" />
				<span>{{ item.label }}</span>
			</button>
		}
	</div>

	<div class="voorkeuren">
		<div class="kop-voorkeuren">Voorkeuren</div>
		<app-toggle-button [block]="true" [checked]="!!navigatieVoorkeurService.nieuweNavigatie()" (toggled)="onNavigatieToggle($event)">
			<span class="voorkeur-titel">Verbeterde navigatie</span>
			<span class="voorkeur-uitleg">Activeer om de verbeterde navigatie layout te gebruiken</span>
		</app-toggle-button>
	</div>
</div>
